import { vendorService } from "../services";
import { VendorT } from "../types";
import { handleError, withRetry } from "../utils";
import { showToast } from "../utils/toastUtils";

export const createVendor = async (data: VendorT) => {
  return withRetry(async () => {
    const res = await vendorService.post("/vendors", data);
    return res.data;
  }).catch(handleError);
};

export const getVendor = async (id: string) => {
  return withRetry(async () => {
    const res = await vendorService.get(`/vendors/${id}`);
    return res.data;
  }).catch(handleError);
};

export const editVendor = async (id: string, data: VendorT) => {
  return withRetry(async () => {
    const res = await vendorService.patch(`/vendors/${id}`, data);
    showToast("Vendor updated successfully!", "success")
    return res.data;
  }).catch(handleError);
};

export const deleteVendor = async (id: string) => {
  return withRetry(async () => {
    const res = await vendorService.delete(`/vendors/${id}`);
    showToast("Vendor deleted successfully!", "success")
    return res.data;
  }).catch(handleError);
};

export const getVendorReport = async (
  startDate: string,
  endDate: string,
  downloadType: "csv" | "pdf"
) => {
  return withRetry(async () => {
    const res = await vendorService.get(
      `/vendors/report?startDate=${startDate}&endDate=${endDate}&downloadType=${downloadType}`
    );
    return res.data;
  }).catch(handleError);
};